import { useEffect } from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import { translate } from "../../../../../../components/translate/translate.jsx";

const BarChartContent = ({data, elementId, title, elementLabels, elementValues = 'qty', translateLabels = false, top = null}) => {

    useEffect(() => {
        if (!data?.length) return;

        const labels = [];
        const values = [];

        data.forEach((element) => {
            labels.push(translateLabels ? translate(element[elementLabels]) : element[elementLabels]);
            values.push(element[elementValues] ?? 0);
        });

        GraphicUtils.barChart(elementId, top ? values.slice(0, top) : values, top ? labels.slice(0, top) : labels, false);
    }, [data, elementId, elementLabels, elementValues, translateLabels]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{title} {top && data?.length >= top ? ` (TOP ${top})` : ""}</span>
                <div className="mt-1" id={elementId}></div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default BarChartContent;